import { Card, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative'
    },
    image: {
        height: '300px',
        width: '100%',
        objectFit: 'contain'
    },
    text: {
        height: '100px',
        width: '100%',
        overflow: 'auto'
    }
}));

const CommunityChallengeTemplate = ({ challenge }) => {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            {!!challenge.picture && < img src={challenge.picture} className={classes.image}></img>}
            <div className={classes.text}>
                {challenge.text}
            </div>
        </Card>)
}

export default CommunityChallengeTemplate;